<template>
  <div class="Site IndexBox">
    <div class="ScrollBox" ref="myScrollBox">
      <van-nav-bar :border="false" :style="{
        backgroundImage: 'url(' + InitData.setting.index_bg_img + ')', backgroundColor: 'none'
      }">
        <template #left>
          <img :src=InitData.setting.logo_img style="height: 45px;">
        </template>
        <template #right>
          <div style="color: #37774C;border-radius:30px;padding: 4px 3px 1px 3px;"
            @click="goDown"><img :src="`./static/images/download.png`"
              style="width:20px;height:17px;margin-top:1px;"></div>
          <router-link to="/language"
            style="margin-left: 10px;color: #37774C;border-radius:30px;padding: 2px 5px;"><img
              :src="`./static/images/language.png`" style="width:20px;height:20px"></router-link>
			  <router-link to="/message"
			    style="margin-left: 10px;color: #37774C;border-radius:30px;padding: 2px 5px;">
				<svg v-if="MessageList.length > 0" xmlns="http://www.w3.org/2000/svg"
				     width="24" height="24"
				     viewBox="0 0 24 24"
				     fill="#37774C">
				  <!-- 实心信封 -->
				  <rect x="3" y="5" width="18" height="14" rx="2" ry="2"/>
				  <!-- 折叠线使用白色描边，使图标仍然可辨 -->
				  <polyline points="3,5 12,13 21,5"
				            fill="none"
				            stroke="#FFFFFF"
				            stroke-width="2"
				            stroke-linecap="round"
				            stroke-linejoin="round"/>
				  <!-- 右上角的白色小圆点，表示「有未读」 -->
				  <circle cx="18" cy="8" r="3" fill="#ff5500"/>
				</svg>
				
				<svg v-else xmlns="http://www.w3.org/2000/svg"
				     width="24" height="24"
				     viewBox="0 0 24 24"
				     fill="none"
				     stroke="#37774C"
				     stroke-width="2"
				     stroke-linecap="round"
				     stroke-linejoin="round">
				  <!-- 信封外框 -->
				  <rect x="3" y="5" width="18" height="14" rx="2" ry="2"/>
				  <!-- 信封盖（折叠线） -->
				  <polyline points="3,5 12,13 21,5" />
				</svg>
				  
				  </router-link>
				  
        </template>
		
      </van-nav-bar>


      <div style="background: url('./static/images/home/index-top-bg@2x.png') 0% 0% / 100% 100%;">
        <div style="margin: 0 auto;">
          <van-swipe :autoplay="3000" indicator-color="#888" style="height:160px">
            <van-swipe-item v-for="(item, index) in InitData.bannerList" :key="index">
              <img :src="item" width="100%" height="160px" />
            </van-swipe-item>
          </van-swipe> 

          <!-- <van-cell class="Broadcast" :border="false" style="">
            <template #icon>
              <van-icon name="volume" color="#37774C" size="1.13rem"
                style="margin-right: 0.322rem; margin-top: 0.5rem" />
            </template>
            <van-swipe style="height: 2.5rem" :show-indicators="false" vertical :autoplay="3000">
              <van-swipe-item style="height: 2.5rem;" v-for="(item, index) in InitData.userviplist" :key="index"
                v-html="$t('home.broadcast', { member: item.username, vipname: item.child_vip_name, grade: item.name, reward: item.amount, currency: InitData.currency })"></van-swipe-item>
            </van-swipe>
          </van-cell> -->
          <!-- <van-row style="margin: 10px 10px;">
            <van-col span="14" style="background: url('./static/images/home/index-menu1@2x.png');background-size: 100% 131px;height: 131px;" @click="toCoins">
                <div style="font-size: 16px;margin-top: 15px;padding-left: 14px;color: #333333;"><span style="font-weight: 800;">{{$t('home.myCoins')}}</span> <span style="color: #999999;">></span></div>
                <div style="font-size: 26px;padding-left: 14px;color: #DC4F3E;">{{InitData.currency}}{{ Number(UserInfo.balance?UserInfo.balance:0) }}</div>
            </van-col>
            <van-col span="9" style="background: url('./static/images/home/index-menu2@2x.png');background-size: 100% 131px; height: 131px;" offset="1" @click="toVip">
                <div style="font-size: 16px;margin-top: 15px;padding-left: 14px;color: #BF6900;"> {{UserInfo.useridentity?UserInfo.useridentity: 'M '+$t('home.leval')}}</div>
                <div style="font-size: 12px;padding-left: 14px;color: #999999;">{{$t('home.view')}} ></div>
            </van-col>
        </van-row> -->

          <!-- <van-row style="margin-left: 10px;margin-top: 12px;">
          <van-col
            style="width:47%;background: url('./static/images/home/recharge-bg@2x.png') 100% no-repeat;background-size: 100% 70px;padding: 22px 105px 24px 30px;height: 89px;"
            @click="toRecharge">
            <div style="font-size: 14px;color: #fff;font-weight: 500;white-space: nowrap;padding-top: 20px;">{{$t('fundRecord.tabs[2]')}}</div>
          </van-col>
          <van-col
            style="width:47.5%;background: url('./static/images/home/Withdrawal-bg@2x.png') 100% no-repeat;background-size: 100% 70px; padding: 22px 103px 24px 31px;height: 89px;"
            offset="1" @click="toWithdraw">
            <div style="font-size: 14px;color: #fff;font-weight: 500;height: 22px;padding-top: 20px;">{{$t('wallet.default[2]')}}</div>
          </van-col>
        </van-row> -->
        </div>
      </div>

      <van-grid class="Menu" direction="vertical" :gutter="10" :column-num="4" :border="false">
        <van-grid-item to="/profile" style="width: 80px;">
          <template #icon>
            <img :src="`./static/images/home/gongshijianjie@2x.png`" style="height:3.5rem;width: 3.5rem;" width="3.5rem"
              height="3.5rem" />
          </template>
          <template #text>
            <span style="font-size: 14px;white-space: pre-wrap;word-wrap: break-word;text-align: center;width:80px;">{{
              $t("user.menu[15]") }}</span>
          </template>
        </van-grid-item>
        <van-grid-item @click="openVideo" style="width: 80px;">
          <template #icon>
            <img :src="`./static/images/home/shipingjiaocheng@2x.png`" style="height: 3.5rem;width: 3.5rem;"
              width="3.5rem" height="3.5rem" />
          </template>
          <template #text>
            <span style="font-size: 14px;white-space: pre-wrap;word-wrap: break-word;text-align: center;width:80px;">{{
              $t("user.menu[16]") }}</span>
          </template>
        </van-grid-item>
        <van-grid-item to="/promote" style="width: 80px;">
          <template #icon>
            <img :src="`./static/images/home/yq.png`" style="height: 3.5rem;width: 3.5rem;" width="3.5rem"
              height="3.5rem" />
          </template>
          <template #text>
            <span style="font-size: 14px;white-space: pre-wrap;word-wrap: break-word;text-align: center;width:80px;">{{
              $t("user.menu[7]") }}</span>
          </template>
        </van-grid-item>
        <!-- <van-grid-item to="/user/list" style="width: 80px;"> -->
        <van-grid-item @click="openUserList" style="width: 80px;">
          <template #icon>
            <img :src="`./static/images/home/wz.png`" style="height: 3.5rem;width: 3.5rem;" width="3.5rem"
              height="3.5rem" />
          </template>
          <template #text>
            <span style="font-size: 14px;white-space: pre-wrap;word-wrap: break-word;text-align: center;width:80px;">{{
              $t('user.office[3]') }}</span>
          </template>
        </van-grid-item>
      </van-grid>

      <van-grid class="Menu" direction="vertical" :gutter="10" :column-num="4" :border="false">
        <van-grid-item @click="goFund" style="width: 80px;">
          <template #icon>
            <img :src="`./static/images/home/yuebao@2x.png`" style="height: 3.5rem;width: 3.5rem;" width="3.5rem"
              height="3.5rem" />
          </template>
          <template #text>
            <span style="font-size: 14px;white-space: pre-wrap;word-wrap: break-word;text-align: center;width:80px;">{{
              $t("user.menu[13]") }}</span>
          </template>
        </van-grid-item>
		<!-- <van-grid-item to="/help" style="width: 80px;">
		  <template #icon>
		    <img :src="`./static/images/mine/mine_bzzx@2x.png`" style="height: 3.5rem;width: 3.5rem;" width="3.5rem"
		      height="3.5rem" />
		  </template>
		  <template #text>
		    <span style="font-size: 14px;white-space: pre-wrap;word-wrap: break-word;text-align: center;width:80px;">{{ $t("user.menu[9]") }}</span>
		  </template>
		</van-grid-item> -->
		<van-grid-item @click="goRed" style="width: 80px;">
          <template #icon>
            <img :src="`./static/images/home/hb.png`" style="height: 3.5rem;width: 3.5rem;" width="3.5rem" height="3.5rem" />
          </template>
          <template #text>
            <span style="font-size: 14px;white-space: pre-wrap;word-wrap: break-word;text-align: center;">{{
              $t('user.menu[21]') }}</span>
          </template>
        </van-grid-item>
		<van-grid-item to="/activity" style="width: 80px;">
		  <template #icon>
		    <img :src="`./static/images/home/activity1.png`" style="height: 3.5rem; width: 3.5rem;" />
		  </template>
		  <template #text>
		    <span style="font-size: 14px;white-space: pre-wrap;word-wrap: break-word;text-align: center;width:80px;">{{
		      $t('user.menu[22]') }}</span>
		  </template>
		</van-grid-item>
        <!-- <van-grid-item @click="goLucky" style="width: 80px;">
          <template #icon>
            <img :src="`./static/images/home/xingyunzhuanpan@2x.png`" style="height: 3.5rem;width: 3.5rem;"
              width="3.5rem" height="3.5rem" />
          </template>
          <template #text>
            <span style="font-size: 14px;white-space: pre-wrap;word-wrap: break-word;text-align: center;width:80px;">{{
              $t("user.menu[12]") }}</span>
          </template>
        </van-grid-item> -->
		<van-grid-item @click="goDaily" style="width: 80px;">
		  <template #icon>
		    <img :src="`./static/images/home/daily.png`" style="height: 3.5rem;width: 3.5rem;"
		      width="3.5rem" height="3.5rem" /> 
		  </template>
		  <template #text>
		    <span style="font-size: 14px;white-space: pre-wrap;word-wrap: break-word;text-align: center;width:80px;">{{
		      $t("postRecord[8]") }}</span>
		  </template>
		</van-grid-item>
		<van-grid-item to="/information" style="width: 80px;">
		  <template #icon>
		    <img :src="`./static/images/home/Icon@2x.png`" style="height: 3.5rem;width: 3.5rem;"
		      width="3.5rem" height="3.5rem" /> 
		  </template>
		  <template #text>
		    <span style="font-size: 14px;white-space: pre-wrap;word-wrap: break-word;text-align: center;width:120px;">{{
		      $t("postRecord[10]") }}</span>
		  </template>
		</van-grid-item>

        <!-- <van-grid-item @click="goDirectMembers" style="width: 80px;">
          <template #icon>
            <img :src="`./static/images/home/lb.png`" style="height: 3.5rem;width: 3.5rem;" width="3.5rem"
              height="3.5rem" />
          </template>
          <template #text>
            <span style="font-size: 14px;white-space: pre-wrap;word-wrap: break-word;text-align: center;width:80px;">{{
              $t('user.menu[20]') }}</span>
          </template>
        </van-grid-item> -->
        
        <van-grid-item v-if="InitData.setting.is_smart == 1" to="/smart" style="width: 80px;">
          <template #icon>
            <img :src="`./static/icon/smart.png`" style="height: 3.5rem;width: 3.5rem;" width="3.5rem"
              height="3.5rem" />
          </template>
          <template #text>
            <span style="font-size: 14px;white-space: pre-wrap;word-wrap: break-word;text-align: center;width:80px;">{{
              $t('user.menu[14]') }}</span>
          </template>
        </van-grid-item>
        <!-- <van-grid-item to="/activity" style="width: 80px;">
          <template #icon>
            <img :src="`./static/images/home/activity.png`" style="height: 3.5rem; width: 3.5rem;" />
          </template>
          <template #text>
            <span style="font-size: 14px;white-space: pre-wrap;word-wrap: break-word;text-align: center;width:80px;">{{
              $t('user.menu[22]') }}</span>
          </template>
        </van-grid-item> -->
      </van-grid>
	  
	  <!--团队轮播-->
	  
	  <van-swipe
	    :autoplay="3000" 
	    :show-indicators="false"
	    :loop="true"
	    v-if="InitData.teamList.length>0"
		
	  >
	    <van-swipe-item 
	      v-for="(group, index) in chunkArray(InitData.teamList, 2)" 
	      :key="index"
	    >
	      <div style="display: grid;grid-template-columns: repeat(2, 1fr);gap: 10px; padding: 10px;">
	        <img 
	          v-for="(item, subIndex) in group"
	          :key="subIndex"
	          :src="item"
	          style=" width: 100%;height: 160px;border-radius: 8px;object-fit: cover;"
	           @click="$router.push(`/activity`)"
	        >
	      </div>
	    </van-swipe-item>
	  </van-swipe>

      <div class="recharge-withdraw-wrap">
        <div class="recharge-withdraw-btn recharge-btn" :style="{ backgroundImage: rechargeBtnBg }" @click="toRecharge">
          <div class="btn-text">{{ formatWalletText($t('wallet.default[1]')) }}</div>
        </div>
        <div class="recharge-withdraw-btn withdraw-btn" :style="{ backgroundImage: withdrawBtnBg }" @click="toWithdraw">
          <div class="btn-text">{{ formatWalletText($t('wallet.default[2]')) }}</div>
        </div>
      </div>

      <div class="earnings-cards">
        <div
          class="earnings-card earnings-card-today"
          style="background-image: url('./static/images/home/today_bg.png');"
        >
          <div class="earnings-card-label">{{ $t('user.myEarnings.grid[2]') }}</div>
          <div class="earnings-card-amount">
            {{ UserInfo.today_earnings ? UserInfo.today_earnings : 0 }}{{ InitData.currency }}
          </div>
        </div>
        <div
          class="earnings-card earnings-card-total"
          style="background-image: url('./static/images/home/total_bg.png');"
        >
          <div class="earnings-card-label">{{ $t('user.myEarnings.grid[6]') }}</div>
          <div class="earnings-card-amount">
            {{ Number(UserInfo.total_profit ? UserInfo.total_profit : 0) }}{{ InitData.currency }}
          </div>
        </div>
      </div>

     <!-- <div>
        <h3 style="padding-top: 10px;padding-left: 20px;font-weight: 800;">
          {{ $t('home.taskHall.title[0]') }} -->
          <!-- <div style="float:right;font-size:12px;color:#666;padding-right:10px;padding-top:10px;">{{ $t('home.taskHall.title[2]')}}</div> -->
        <!-- </h3>
        <div
          style="margin: 15px;padding: 15px;box-shadow: -2px 1px 5px 4px rgba(0,0,0,0.04);background-color: #fff;height: 160px;border-radius:15px;">
          <div style="font-size: 14px;padding-bottom: 35px;display: flex; flex-direction: row; justify-content: space-between;">
            <div>{{ $t('task.default[10]') }} <span style="float: right;color: #37774C;">({{ UserInfo.task_wc_num ? UserInfo.task_wc_num : 0 }}/{{
                UserInfo.number ? UserInfo.number : 0 }})</span></div>
            <img :src="`./static/images/home/refresh.png`" @click="refresh()" style="width: 25px;height:25px;">
          </div>
          <div class="custom-progress">
            <van-progress :pivot-text="percentage + '%'" stroke-width="10" color="#37774C" :percentage="percentage"
              style="margin-bottom: 15px;height:10px" /> -->
            <!-- <van-icon
              name="fire-o"
              class="progress-icon"
              :style="iconStyle"
            /> -->
            <!-- <img name="fire-o" class="progress-icon" :style="iconStyle" :src="`./static/images/bike.png`"
              style="width: 27px;height: 21px;" />
          </div>
          <div style="display: flex;justify-content: center;padding-top: 10px;">
            <van-button round type="info" style="width:70%;" color="#37774C" block @click="batchTask()">{{ $t('task.default[11]') }}</van-button>
          </div>
        </div>
      </div> -->

      <!-- <h3 style="padding-top: 10px;padding-left: 20px;font-weight: 800;">
          <span>{{$t('home.title[0]')}}</span>
          <div @click="goMyTask" style="float:right;font-size:12px;color:#666;padding-right:10px;padding-top:10px;">{{$t('home.title[2]')}} ></div>
        </h3> -->
      <van-grid class="jj-list" direction="vertical" :border="false" :gutter="10" :column-num="2"
        style="padding:10px 0 10px 10px;text-align: center;" type="flex" justify="space-between">
        <van-grid-item  v-for="(item,index) in listData" style="background-color: transparent;" @click="goPost(item.order_id)">
          <div v-if="index>=(UserInfo.number-UserInfo.task_wc_num) || is_expired==1" style="position: absolute;padding: 10px 15px;position: absolute;padding: 10px 5px;height: 255px;width: 100%;z-index: 999;">
            <div class="item-task-mock">
              <img :src="`./static/images/home/lock@2x.png`" style="width:59px;height:59px;margin-top:50px;"/>
              <p style="padding:10px 0; color:#333;">{{$t('home.title[4]')}}</p>
              <van-button round type="info" @click="toVip" color="#37774C" style="height: 30px;width:70%;left:50%;transform: translateX(-50%);"
                block>{{$t('home.title[3]')}}</van-button>
            </div>
          </div>
          <div class="jj-list-item">
            <div style="text-align: center;">
              <img :src="item.link_info" style="width: 100px;height:100px;border-radius:15px;">
            </div>
            <div style="padding:0 10px;padding-top: 10px;">
              <h4 style="font-size: 10px;">{{ item.title }}</h4>
              <p style="font-size: 12px;color:#37774C;">{{ item.reward_price }}<span style="font-size: 12px;color:#9a9a9a;">{{ InitData.currency }}</span></p>
              <p v-if="item.code && UserInfo.vip_level > 1" style="font-size: 12px;">ID：{{ item.code }}</p>
              <p v-else style="font-size: 12px;">ID：{{ $t('task.show[8]') }}</p>
            </div>
            <div style="padding-top: 8px;">
              <van-button round v-if="item.order_id == 0" type="info" color="#37774C" style="height: 30px;" block
                @click="onReceiveTask(item.task_id)">{{ $t('task.default[9]') }}</van-button>
              <van-button round v-if="item.order_id > 0 && item.status == 1" type="info" color="#7ad3a2"
                style="height: 30px;" block @click="goPost(item.order_id)">{{ $t('task.default[10]') }}</van-button>
              <van-button round v-if="item.order_id > 0 && item.status == 3" type="info" color="#37774C" style="height: 30px;"
                block disabled>{{ $t('postRecord[3]') }}</van-button>
            </div>
          </div>
        </van-grid-item>
      </van-grid>
	  <router-link to="/user/newLc" class="invite_box">
	    <img :src="`./static/images/banenr@2x.png`" width="100%" style="padding: 0 10px;border-radius: 10px;">
	  </router-link>
      <!-- <div style="height: 130px;padding: 0 10px;">
        <ezflycard
          @onDragMove='onCardDragMove'
          @onDragStop='onCardDragStop'
          @onThrowDone='onCardThrowDone'
          :cardWidth="380" 
          :cardHeight="100"
          :throwTriggerDistance="100"
          :cardBgColor="'transparent'"
          dragDirection="horizontal"
          :hasShadow="false"
          v-if="InitData.memberList.length>0"
        >
          <div slot="firstCard" style="width:100%;height:120px;">
            <van-cell 
              class="item-view"
              style="background: url('./static/images/msg_bk_1@2x.png'); background-size: 100% 100%;"
              :label="InitData.memberList[activeIndex].create_time"
              center
            >
              <template #title>  
                <div
                  style="color: #fff;padding-right: 50px;white-space: pre-wrap;word-wrap: break-word;justify-content: center; align-items: center;line-height:10px;font-size:12px"
                >
                  <div style="text-align: left;">{{ $t("home.broadcast", { member: InitData.userviplist[activeIndex].username,vipname:InitData.userviplist[activeIndex].child_vip_name,currency:InitData.currency,grade:InitData.userviplist[activeIndex].name }) }}</div>
                  <div style="text-align: left;">{{ InitData.memberList[activeIndex].complete_time }}</div>
                </div>
              </template>
            </van-cell>
          </div>
          <div slot="secondCard" style="background: url('./static/images/msg_bk_1@2x.png');background-size: 100% 100px;width:100%;height:100%;opacity:0.3;">
          </div>
          <div slot="thirdCard" style="background: url('./static/images/msg_bk_1@2x.png');background-size: 100% 100px;width:100%;height:100%;opacity:0.3;">
          </div>
          <div slot="othCard" style="background: url('./static/images/msg_bk_1@2x.png');background-size: 100% 100px;width:100%;height:100%;opacity:0.3;">
          </div>
        </ezflycard>

      </div> -->

      <h3 v-if="InitData.news" style="padding: 10px 0 10px 20px;font-weight: 800;">
        <span>{{$t('home.title[1]')}}</span>
      </h3>
      <div v-if="InitData.news" style="padding: 0 10px;">
        <div 
          class="news-carousel"
          @mouseenter="pause"
          @mouseleave="resume"
        >
          <div 
            class="carousel-window"
            :style="{ height: '350px' }"
          >
            <div 
              class="carousel-track"
              :style="{ transform: `translateY(${offset}px)` }"
            >
              <div 
                v-for="(item, index) in displayList"
                :key="index"
                class="carousel-item"
                :style="{ height: itemHeight + 'px' }"
                @click="$router.push(`/article/news/${item.id}`)"
              >
                <img :str="item.cover_img" height="90px" width="90px" style="margin-right: 10px;"/>
                <p>{{ item.title }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
	  <div style="height: 130px;padding: 0 10px;">
	    <ezflycard
	      @onDragMove='onCardDragMove'
	      @onDragStop='onCardDragStop'
	      @onThrowDone='onCardThrowDone'
	      :cardWidth="380" 
	      :cardHeight="100"
	      :throwTriggerDistance="100"
	      :cardBgColor="'transparent'"
	      dragDirection="horizontal"
	      :hasShadow="false"
	      v-if="InitData.memberList.length>0"
	    >
	      <div slot="firstCard" style="width:100%;height:120px;">
	        <van-cell 
	          class="item-view"
	          style="background: url('./static/images/msg_bk_1@2x.png'); background-size: 100% 100%;"
	          :label="InitData.memberList[activeIndex].create_time"
	          center
	        >
	          <template #title>  
	            <div
	              style="padding-right: 50px;white-space: pre-wrap;word-wrap: break-word;justify-content: center; align-items: center;line-height:10px;font-size:12px"
	            >
	              <div style="text-align: left;">{{ $t("home.broadcast", { member: InitData.userviplist[activeIndex].username,vipname:InitData.userviplist[activeIndex].child_vip_name,currency:InitData.currency,grade:InitData.userviplist[activeIndex].name }) }}</div>
	              <!-- <div style="text-align: left;">{{ InitData.memberList[activeIndex].complete_time }}</div> -->
	            </div>
	          </template>
	        </van-cell>
	      </div>
	      <div slot="secondCard" style="background: url('./static/images/msg_bk_1@2x.png');background-size: 100% 100px;width:100%;height:100%;opacity:0.3;">
	      </div>
	      <div slot="thirdCard" style="background: url('./static/images/msg_bk_1@2x.png');background-size: 100% 100px;width:100%;height:100%;opacity:0.3;">
	      </div>
	      <div slot="othCard" style="background: url('./static/images/msg_bk_1@2x.png');background-size: 100% 100px;width:100%;height:100%;opacity:0.3;">
	      </div>
	    </ezflycard>
	  
	  </div>
      <div style="height: 50px;"></div>
    </div>
    <Footer />
    
    <!-- 返回顶部按钮 -->
    <div 
      v-show="showBackTop"
      class="back-top"
      @click="scrollToTop"
      style="background: url('./static/images/home/top.png');background-size:  45px 45px;"
    >
    </div>
    <!--公告-->
    <van-popup v-model="showNotice" v-if="InitData.noticelist && InitData.noticelist.length"
      class="notice-popup"
      style="background: transparent; width: 80%; text-align: center" @closed="showNotice = false">
      <div class="NoticePopupL"
        style="background:url('./static/images/bg@2x.png') ;width: 100%;background-size: cover;background-position: top center;background-repeat: no-repeat;padding-top: 118px;height: 38.25rem;box-sizing: border-box;"
        v-if="InitData.noticelist && InitData.noticelist.length"
        @click="$router.push(`/article/notice/${InitData.noticelist[currentIndex].id}`)">
        <!-- <h3 style="background-color: rgb(111, 141, 243);color: #fff;">{{ InitData.noticelist[currentIndex].title }}</h3> -->
        <div class="txt">
          <!-- <div style="color: #999; text-align: center;font-size: 16px;">{{ InitData.noticelist[currentIndex].title }}</div> -->
          <div
            style="word-wrap: break-word;margin-top: 100px;background-color: #FFE3E3;width: 94%;max-height: 20rem;height: 20rem;margin-left: 3%;border-radius: 10px;padding: 2px;overflow-y: auto; font-size: 14px;   line-height: 1.5;"
            v-html="InitData.noticelist[currentIndex].content"></div>
        </div>
        <div style="display: flex;justify-content: center;margin: 10px 0">
          <van-button size="small" round block
            style="color: #fff;font-size: 16px;background: #37774C;width: 100px;margin-right: 10px;"
            :disabled="currentIndex == 0" @click.stop="preNotice">{{ $t('home.noticeTitle[1]') }}</van-button>
          <van-button size="small" round block style="color: #fff;font-size: 16px;background: #37774C;width: 100px;"
            :disabled="currentIndex == InitData.noticelist.length - 1" @click.stop="nextNotice">{{
              $t('home.noticeTitle[2]')
            }}</van-button>
        </div>
      </div>
      <a class="close" href="javascript:;" @click="showNotice = false"><van-icon name="clear"
          color="rgba(255,255,255,.8)" size="2.5rem" /></a>
    </van-popup>
    <!--红包-->
    <van-popup v-model="showRed" style="background: transparent; width: 80%; text-align: center">
      <dl style="background: #fff;border-radius: 5px;">
        <img :src="`./static/images/home/b_bg.png`" width="100%" height="115px">
        <dt style="text-align:left;padding-left: 20px;" v-html="$t('home.bonus[0]')"></dt>
        <!-- <dt style="text-align:left;padding-left: 20px;">{{ $t('home.bonus[1]') }}</dt> -->
        <dt style="padding: 10px;">
          <van-field v-model="pwd" :placeholder="$t('home.bonus[2]')"
            style="background: #d0cccc;color:#fff;margin-left:20px;width:85%" />
        </dt>
        <dt>
          <van-button :disabled="dis" round @click="getBonus"
            style="font-size: 18px;background-color:#37774C; width: 80%;color:#fff">{{ $t('home.bonus[3]')
            }}</van-button>
        </dt>
      </dl>
      <a class="close" href="javascript:;" @click="showRed = false">
        <van-icon name="clear" color="rgba(255,255,255,.8)" size="2.5rem" />
      </a>
    </van-popup>
    
    <van-popup v-model="showTfCrad" style="background: transparent; text-align: center">
      <dl style="background: url('./static/images/home/tf_bg.png') 100% 100%;background-size: 270px 450px;width: 270px;height: 450px; border-radius: 5px;padding-top: 230px;">
        <!-- <img :src="`./static/images/home/tf_bg.png`" width="100%" height="115px"> -->
        <dt style="margin:0 25px;width: 218px;height: 115px;background: #FFE3E3;border-radius: 15px 15px 15px 15px;padding:5px;border: 1px solid #EAEAEA;margin-top: 30px;display: -webkit-box; overflow: hidden; text-overflow: ellipsis;-webkit-line-clamp: 6;-webkit-box-orient: vertical;">{{ $t('home.title[6]')}}</dt>
        <dt style="margin-top: 20px;">
          <van-button round @click="submitTfCrad"
            style="font-size: 18px;background-color:#37774C; width: 80%;color:#fff">{{ $t('home.title[5]')
            }}</van-button>
        </dt>
      </dl>
      <a class="close" href="javascript:;" @click="showTfCrad = false">
        <van-icon name="clear" color="rgba(255,255,255,.8)" size="2.5rem" />
      </a>
    </van-popup>
    <!--消息提醒-->
    <van-popup v-model="showMsg" 
    :close-on-click-overlay="false"
    v-if="MessageList && MessageList.length"
      style="background: transparent; width: 80%; text-align: center">
      <div class="NoticePopupL" style="height: 300px;" @click="$router.push(`/article/message/${MessageList[0].id}`)">

        <div class="txt">
          <img :src="`./static/images/sx.gif`" width="100%">
        </div>
        <!-- <van-button round block
          style="background-color: rgb(55, 119, 76);color: #fff;width: 170px;margin:0 auto;margin-bottom:13px">Click to view</van-button> -->
      </div>
       <a class="close" href="javascript:;" @click="showMsg = false"><van-icon name="clear"
          color="rgba(255,255,255,.8)" size="2.5rem" /></a>
    </van-popup>

      <div id="telegram">
        <img :src="`./static/images/telegram.png`" @click="openKefu(InitData.setting.telegram_url)" width="40" style="border-radius: 30px;">
          <!-- telegram -->
      </div>
  </div>
</template>

<script>
import ezflycard from "@/components/ezflycard.vue"
export default {
  name: "Home",
  inject: ["reloadHtml"],
  components: { ezflycard },
  props: [],

  data() {
    return {
      activeIndex: 0,
      currentIndex: 0,
      showService: false,
      showNotice: false,
      showRed: false,
      showMsg: false,
      pwd: '',
      dis: false,
      listData: '',
      percentage: 0,
      showTfCrad:false,
      showBackTop: false,
      scrollThreshold: 200,
      newsCurrentIndex: 0,
      timer: null,
      isPaused: false,
      itemHeight:120,
      interval:3000,
      visibleCount:3,
      is_expired:0,
      Tasktimer:null,
      total_processing_hours:0,
      total_completed_hours:0,
      staticBasePath: ''
    };
  },
  computed: {
    // 兼容根路径与 /sgm 等子路径的静态资源地址
    rechargeBtnBg() {
      const base = this.staticBasePath || '';
      return `url(${base}/static/images/home/Item1@2x.png)`;
    },
    withdrawBtnBg() {
      const base = this.staticBasePath || '';
      return `url(${base}/static/images/home/Item2@2x.png)`;
    },
    cardList() {
      let data = this.$store.state.BankCardList.flatMap(item => item.bank_name + ' ' + item.card_no.replace(/^(.{4}).*(.{4})$/, '$1 **** $2'))
      return data;
    },
    // 动态计算图标位置（跟随进度）
    iconStyle() {
      let len = this.percentage > 40 ? this.percentage : this.percentage + 3;
      return {
        left: `${len}%`,
        transform: 'translateX(-50%)' // 水平居中
      }
    },
    scrollElement() {
      return this.$refs.myScrollBox
    },
    
    originLength() {
      return this.InitData.news?this.InitData.news.length: 0
    },
    windowHeight() {
      return this.itemHeight * this.visibleCount
    },
    displayList() {
      var news =[]
      if(this.InitData.news){
        const cloneCount = Math.max(this.visibleCount, 1)
        news = [...this.InitData.news, ...this.InitData.news.slice(0, cloneCount)]
      }
      return news
    },
    offset() {
      return -this.newsCurrentIndex * this.itemHeight
    }
  },
  watch: {
    'MessageList'(data) {
      if (data.length) this.showMsg = true
    },
  },
  created() {
    this.$Model.GetBackData();
    if (this.UserInfo.vip_level) {
      this.$Model.GetUserInfo((res)=>{
        this.showTfCrad = res.info.is_card==0 && res.info.vip_level<2;
      });
      this.$Model.getUnreadMsg();
      this.$Model.GetBankCardList();
      this.$Model.getDailyTaskProgress((res) => {
        if (res.code == 200 && res.data) {
          this.percentage = res.data.percentage > 100 ? 100 : res.data.percentage
          this.total_completed_hours = res.data.total_completed_hours * 60*60;
          this.total_processing_hours = res.data.total_processing_hours * 60*60; 
        }
      });
    }
    this.listData = this.getTaskList();

    if (this.InitData.noticelist.length) {
      this.showNotice = true;
    }

    // 静态资源前缀，兼容部署在 /sgm 等子路径
    if (typeof window !== 'undefined' && window.location && window.location.pathname) {
      const path = window.location.pathname || '/';
      const segments = path.split('/').filter(Boolean);
      this.staticBasePath = segments.length > 0 ? `/${segments[0]}` : '';
    }
  },
  mounted() {
    const container = document.querySelector('.ScrollBox')
    this.startAutoPlay()
    container.addEventListener('scroll', this.handleScroll)
    if (this.InitData.memberList && this.InitData.memberList.length) {
      this.$nextTick(() => {
        const data = $("#SwipeList1 .van-swipe-item").slice(0, 5);
        for (var i = 0; i < data.length; i++) {
          $("#SwipeList1").children().append($(data[i])[0].outerHTML);
        }
      });
    }
    if (this.InitData.businessList && this.InitData.businessList.length) {
      this.$nextTick(() => {
        const data = $("#SwipeList2 .van-swipe-item").slice(0, 5);
        for (var i = 0; i < data.length; i++) {
          $("#SwipeList2").children().append($(data[i])[0].outerHTML);
        }
      });
    }
    this.timer = setInterval(() => {
      
      this.total_completed_hours = this.total_completed_hours+1;
      this.percentage = this.total_processing_hours==0?0:this.total_completed_hours/this.total_processing_hours*100;
      this.percentage = this.percentage > 100 ? 100 : this.percentage.toFixed(2);
    }, 1000)
  },
  beforeDestroy() {
    const container = document.querySelector('.ScrollBox')
    container.removeEventListener('scroll', this.handleScroll)
    clearInterval(this.timer)
    clearInterval(this.Tasktimer)
    this.timer = null
    this.Tasktimer = null
  },
  activated() { },
  destroyed() { },
  methods: {
     openKefu(url) {
      window.location.href = url;
    },
    formatWalletText(text) {
      if (!text) return '';
      const str = String(text);
      if (str.length > 12) {
        return str.slice(0, 8) + '\n' + str.slice(8);
      }
      return str;
    },
	  chunkArray(arr, size) {
	    return Array.from({ length: Math.ceil(arr.length / size) }, (v, i) =>
	      arr.slice(i * size, i * size + size)
	    );
	  },
    next() {
      this.newsCurrentIndex++
      if (this.InitData.news && this.newsCurrentIndex > this.originLength) {
        setTimeout(() => {
          const track = this.$el.querySelector('.carousel-track')
          track.style.transition = 'none'
          this.newsCurrentIndex = 0
          
          this.$nextTick(() => {
            track.style.transition = 'transform 0.5s ease-in-out'
          })
        }, 2000)
      }
    },
    startAutoPlay() {
      if (!this.timer) {
        this.timer = setInterval(() => {
          if (!this.isPaused) this.next()
        }, this.interval)
      }
    },
    pause() {
      this.isPaused = true
    },
    resume() {
      this.isPaused = false
    },
    handleScroll() {
      if (!this.scrollElement) return
      this.showBackTop = this.scrollElement.scrollTop > 200
    },
    scrollToTop() {
      if (!this.scrollElement) return
      const start = this.scrollElement.scrollTop
      const duration = 500
      const startTime = performance.now()

      const animate = (time) => {
        const elapsed = time - startTime
        const progress = Math.min(elapsed / duration, 1)
        this.scrollElement.scrollTop = start * (1 - progress)
        if (progress < 1) {
          requestAnimationFrame(animate)
        }
      }
      requestAnimationFrame(animate)
    },
    refresh(){
      this.$Model.getDailyTaskProgress((res) => {
        if (res.code == 200 && res.data) {
          this.percentage = res.data.percentage > 100 ? 100 : res.data.percentage
          this.total_completed_hours = res.data.total_completed_hours * 60*60;
          this.total_processing_hours = res.data.total_processing_hours * 60*60; 
        }
      });
      this.$Model.GetUserInfo((res)=>{
        this.showTfCrad = res.info.is_card==0 && res.info.vip_level<2;
      });
    },
    goLucky() {
      if (this.InitData.setting.is_lucky == 2) {
        this.$Dialog.Alert(this.$t('home.lucky'));
      } else {
        this.$router.push(`/lucky`);
      }
    },
    goDaily() {
      // this.$Dialog.Toast(this.$t('task.index[7]'));
      this.$router.push(`/postRecord`);
    },
    goFund() {
      if (this.InitData.setting.is_yuebao == 2) {
        this.$Dialog.Alert(this.$t('home.lucky'));
      } else {
        this.$router.push(`/user/newLc`);
      }
    },
    goDirectMembers() {
      this.$Dialog.Alert(this.$t('home.lucky'));
    },
    onReceiveTask(id) {
      this.$Model.ReceiveTask(id, data => {
        if (data.code == 1) {
          this.$router.push(`/taskShow/${data.new_id}`);
        } else {
          this.$Dialog.Alert(data.code_dec);
        }
      })
    },
    onReceiveALLTask() {
      this.$Model.receiveAllTasks(data => {
        if (data.code == 1) {
          this.getTaskList();
        } else {
          this.$Dialog.Alert(data.code_dec);
        }
      })
    },
    onCardDragMove(obj) {

    },
    onCardDragStop(obj) {

    },
    onCardThrowDone(obj) {
      if (this.activeIndex == this.InitData.memberList.length - 1) {
        this.activeIndex = 0;
      } else {
        this.activeIndex++;
      }
    },
    preNotice() {
      this.currentIndex = this.currentIndex - 1
    },
    nextNotice() {
      this.currentIndex = this.currentIndex + 1
    },
    openUserList() {
      // this.$Dialog.Toast(this.$t('task.index[7]'));
      this.$router.push(`/user/apply`);
    },
    submitTfCrad(){
      this.$Model.submitTfCrad(data => {
        if (data.code == 1) {
          this.$router.push(`/T`);
        } else {
          this.$Dialog.Alert(data.code_dec);
        }
      })
    },
    getBonus() {
      if (!this.pwd) {
        this.$Dialog.Toast(this.$t('home.bonus[2]'))
        return
      }
      this.$Model.doBonus(this.pwd, data => {
        if (data.code == 1) {
          this.$Dialog.Alert(this.$t('home.bonus[4]', { amount: data.amount }), data => {
            this.showRed = false
          })
          this.pwd = ''
          //this.dis = true
        } else {
          this.$Dialog.Alert(data.code_dec);
          //this.dis = false
        }
      })
    },
    goRed() {
      this.showRed = true
      this.pwd = ''
    },
    goDown() {
      const u = navigator.userAgent;
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      if (isiOS) {
        this.$Util.OpenUrl(this.InitData.setting.ios_url);
      } else {
        this.$Util.OpenUrl(this.InitData.setting.h_server_name);
      }
    },
    goTask(index, state, tid) {
      if (state == 3) {
        this.$toast.fail(this.$t("home.msg"));
      } else {
        if (this.UserInfo.vip_level) {
          this.$router.push(`/taskList/${tid}/${this.UserInfo.vip_level}`);
        } else {
          this.$router.push(`/task/${index}`);
        }
      }
    },
    goMyTask() {
      // if (this.UserInfo.task_wc_num >= this.UserInfo.number) {
      //   this.$Dialog.Toast(this.$t('task.msg'));
      // } else {
        this.$router.push(`/myTask`);
      // }

    },
    batchTask(){
		this.$router.push(`/myTask`);
      // if (this.UserInfo.vip_level <3) {
      //   this.$router.push(`/T`);
      // }else if (this.UserInfo.vip_level == 1) {
      //   this.$router.push(`/myTask`);
      // } else {
      //   this.onReceiveALLTask();
      // }
    },
    goPost(id) {
      // this.$router.push({ name: "postTask", query: { type: id } });
      // if (this.UserInfo.task_wc_num >= this.UserInfo.number) {
      //   this.$Dialog.Toast(this.$t('task.msg'));
      // } else {
		  console.log(id)
      if (id > 0) {
        this.$router.push(`/taskShow/${id}`);
      }

      //}

    },
    openVideo() {
      this.$router.push(`/article/video`);
    },
    toRecharge() {
      this.$router.push(`/user/recharge`);
    },
    toWithdraw() {
      if (this.UserInfo.is_fund_password != 1) {
        this.$Dialog.Alert(this.$t('wallet.msg[0]'), () => {
          this.$router.push('/user/info/fpwd')
        })
      } else {
        if (this.cardList.length) {
          this.$router.push(`/user/withdraw`);
        } else {
          this.$Dialog.Alert(this.$t('wallet.msg[1]'), () => {
            this.$router.push('/user/bankCard')
          })
        }
      }
    },
    toVip() {
      this.$router.push(`/T`);
    },
    getTaskList() {
      this.$Model.GetTaskRecord({ status: 1, is_u: 1,page_size:4 }, data => {
        if (data.code == 1) {
          this.listData = data.info
          this.is_expired = data.is_expired
        }
      })
    }
  },
};
</script>
<style scoped>
#telegram{
	position: absolute;
    bottom: 16rem;
    right: 0rem;
    z-index: 99;
    color: #999;
    line-height: 1;
    text-align: center;
    font-size: .75rem;
}
#telegram img {
    display: block;
    margin: 0 auto;
}
.Broadcast {
  background-color: rgb(240 94 86/0.1);
  padding: 9px 10px;
  margin: 0px;
  box-shadow: 0 1px 2px rgb(0 0 0 / 20%);
  width: 100%;
  border-radius: 0;

}

.Broadcast .van-swipe-item {
  color: #000;
}

.TaskHall>>>.van-grid-item__content {
  background-color: #fff;
  color: #000;
  padding: 10px 10px;
  justify-content: flex-start;
  text-align: justify;
  border-radius: 5px;
  box-shadow: 0 1px 2px rgb(0 0 0 / 20%);
  border: 1px solid rgba(0, 0, 0, 0.1);
}

.TaskHall>>>.van-grid-item__icon-wrapper {
  margin-right: 10px;
  flex: 1;
  text-align: left;
}

.zh-CN>>>.van-grid-item__icon-wrapper,
.zh-HK>>>.van-grid-item__icon-wrapper {
  word-spacing: 5px;
}

.MemberList {
  overflow: hidden;
  margin-bottom: 5px;
}

.MemberList>>>.van-tabs__wrap {
  margin: 4px 0;
}

.MemberList>>>.van-tabs__nav--card {
  margin: 0;
}

.MemberList>>>.van-icon {
  margin-right: 10px;
}

.MemberList>>>.van-tab__text {
  color: #000;
  display: flex;
  align-items: center;
}

.MemberList .van-swipe-item {
  padding: 1px 0;
}

.topItem {
  line-height: 1;
  background-color: #fff;
  color: #000;
}

.topItem .van-cell__left-icon {
  height: 46px;
  width: 46px;
  background-color: #fff;
  border-radius: 100%;
  overflow: hidden;
  padding: 2px;
}

.topItem .van-icon__image {
  width: 100%;
  height: 100%;
}

.topItem .van-cell__label {
  line-height: 1;
  margin-top: 5px;
}

.topItem .profit {
  background-color: rgba(255, 255, 255, 0.5);
  border-radius: 100px;
  display: flex;
  align-items: center;
  padding: 3px 8px;
  font-size: 13px;
  color: #0e1526;
}

.topItem .profit img {
  margin-right: 5px;
}

.Menu {
  margin: 10px 0;
  background-color: rgba(255, 255, 255, 1);
  border-radius: 8px;
  margin-left: 10px;
  margin-right: 10px;
}

.Menu>>>.van-grid-item__content {
  background-color: #fff;
  color: #000;
  /* border: 1px solid rgba(244, 245, 247, 1); */
  display: flex;
  justify-content: center;
  align-items: center;
  /* box-shadow: 0 1px 2px rgb(0 0 0 / 20%); */
}

.Menu>>>.van-grid-item__icon-wrapper {
  overflow: hidden;
  text-align: center;
  flex: 1;
}

.Title {
  background-color: #fff;
  color: #000;
  font-size: 1.5rem;
  margin: 4px 0;
  padding: 7px 25px;
}

.MemberList>>>.van-tab__text {
  height: 100%;
}

.boder_left {
  width: 200px;
  height: 30px;
  line-height: 30px;
  padding-left: 10px;
  border-left: 5px solid #4F8FF7;
}

/* 收益卡片（今日/总收益）图2样式 */
.earnings-cards {
  display: flex;
  gap: 10px;
  margin: 10px;
}
.earnings-card {
  flex: 1;
  min-height: 100px;
  border-radius: 16px;
  border: 1px dashed rgba(0, 0, 0, 0.12);
  padding: 14px 12px;
  position: relative;
  overflow: hidden;
  background-color: #f1f8f2;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}
.earnings-card-total {
  background-color: #fff8f0;
}
.earnings-card-label {
  font-size: 12px;
  color: #333;
  margin-bottom: 6px;
}
.earnings-card-amount {
  font-size: 18px;
  font-weight: 600;
  color: var(--theme-color);
}

/* 方案3：交互动画竖线 */
.animated-line {
  justify-content: center;
  position: relative;
}

.animated-line::before {
  margin-top: 15px;
  content: '';
  position: absolute;
  left: 50%;
  height: 80%;
  width: 3px;
  background: linear-gradient(180deg, #FFF2F2 0%, #5ecb80 49%, #FFF2F2 97%);
  border-radius: 0px 0px 0px 0px;
}

.custom-progress {
  position: relative;
  /* margin: 20px; */
  height: 20px;
  /* 给图标留出空间 */
}

.progress-icon {
  position: absolute;
  top: -26px;
  /* 图标位于进度条上方 */
  font-size: 20px;
  color: #ee0a24;
  transition: left 0.3s ease;
  /* 添加平滑移动效果 */
}

.jj-list {
  /deep/.van-grid-item__content {
    padding: 0;
    background-color:transparent;
  }

  .jj-list-item {
    width: 100%;
    background-color: #fff;
    color: #000;
    justify-content: flex-start;
    text-align: left;
    border-radius: 10px;
    box-shadow: 0 1px 2px rgb(0 0 0 / 20%);
    border: 1px solid rgba(0, 0, 0, 0.1);
    padding:10px 15px;
  }
}
.item-task-mock{
  width: 100%;
  height: 100%;
  background: rgba(51,51,51,0.55);
  border-radius: 10px 10px 10px 10px;
  /* 关键样式 */
  background: rgba(255, 255, 255, 0.1); /* 半透明底色 */
  backdrop-filter: blur(5px) saturate(150%); /* 模糊+饱和度增强 */
  -webkit-backdrop-filter: blur(5px) saturate(150%);
}
.item-task-mock /deep/.van-button--info{
    border: 3px solid #fff !important;
  }
/* 公告弹窗：允许顶部装饰完整显示，不裁剪 */
.notice-popup>>>.van-popup__content {
  overflow: visible;
}
.NoticePopupL {
  overflow: visible;
}

.back-top {
  position: fixed;
  right: 0;
  bottom: 200px;
  width: 45px;
  height: 45px;
  line-height: 40px;
  text-align: center;
  background: #37774C;
  color: white;
  border-radius: 50%;
  cursor: pointer;
  transition: opacity 0.3s;
  z-index: 999;
}
.carousel-track {
  transition: transform 0.5s ease-in-out;
}
.news-carousel {
  width: 100%;
  overflow: hidden;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.1);
  padding: 10px;
}

.carousel-container {
  overflow: hidden;
  position: relative;
  transition: height 0.3s;
}

.carousel-list {
  transition: transform 0.5s ease-in-out;
}

.carousel-item {
  display: flex;
  align-items: center;
  padding: 0 20px;
  font-size: 16px;
  color: #333;
  padding: 10px 0;
  transition: all 0.3s;
}

.carousel-item:last-child {
  border-bottom: none;
}

.carousel-item:hover {
  background: #f8f9fa;
  transform: translateX(10px);
}
.carousel-item p {
  font-size: 14px;
  color: #666;
  margin: 0;
  /* 多行自动换行 */
  word-wrap: break-word;
  white-space: normal;
  /* 多行省略号（可选） */
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* 充值/提现按钮 - 图片背景样式，文字保留多语言 */
.recharge-withdraw-wrap {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  padding: 0 10px;
}
.recharge-withdraw-btn {
  flex: 1;
  min-height: 70px;
  border-radius: 8px;
  padding: 14px 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-sizing: border-box;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
/* 充值/提现按钮背景图改为模板内联 :style，避免 CSS url 路径问题并兼容 /sgm 子路径 */
.recharge-btn .btn-text { color: #CF8045; }
.withdraw-btn .btn-text { color: #AF615C; }
.btn-text {
  font-size: 14px;
  font-weight: 500;
  /* text-align: center; */
  margin-left: 5px;
  white-space: pre-wrap;
  word-wrap: break-word;
  word-break: break-word;
  line-height: 1.4;
  text-shadow: 0 1px 2px rgba(255,255,255,0.8);
  width: 100%;
}
.btn-icon-wrap {
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  border-radius: 6px;
  border: 1px dashed;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btn-icon-img {
  width: 28px;
  height: 21px;
  object-fit: contain;
}
</style>